import { print } from 'graphql'
import gql from 'graphql-tag'

import axiosql from '../axiosql'

function load() {
    return axiosql('user/graphql', {
        query: print(gql`
            {
                servers {
                    _id
                    name
                    nickname
                }
            }
        `)
    })
}

function loadByID(id) {
    return axiosql('user/graphql', {
        query: print(gql`
            query getPlanByID($id: String!) {
                servers(filter: { _id: $id }) {
                    _id
                    name
                    nickname
                    publicAddress
                    upload
                    download
                }
            }
        `),
        variables: {
            id
        }
    })
}

export { load, loadByID }
